<div class="cooking-story-header">
  <!-- <div class="item shadow">
    <img src="assets/cookingbook/user.svg" alt="" />
    پروفایل
  </div> -->
  <p class="title">خانه</p>
  <!-- <div class="item shadow">
    <img src="assets/profile/setting.svg" alt="" />
    تنظیمات
  </div> -->
</div>
<div class="cooking-story-body">
  <div class="cards">
    <div class="left-coulmn">
      <div class="card" (click)="goTobook()">
        <img src="assets/cookingbook/cooking-book.svg" alt="" />
        <p>کتاب‌آشپزی</p>
      </div>

      <div class="card bigger down" (click)="goToMeMbers()">
        <img src="assets/cookingbook/members.svg" alt="" />
        <p>افراد خانه</p>
      </div>
    </div>
    <div class="middle"></div>
    <div class="right-coulmn">
      <div class="card bigger" (click)="goToKitchen('kitchen')">
        <img src="assets/cookingbook/kitchen.svg" alt="" />
        <p>آشپزخانه</p>
      </div>
      <div class="card down" (click)="goToKitchen('shoppinglist')">
        <img src="assets/cookingbook/list.svg" alt="" />
        <p>لیست خرید</p>
      </div>
    </div>
  </div>
  <div
    class="kitchen-empty"
    *ngIf="suggestPost && suggestPost.recipes.length == 0"
  >
    <p class="kitchen-empty-title">بر اساس مواد آشپزخانه</p>
    <p class="kitchen-empty-detail">
      با وارد کردن مواد غذایی خود در قسمت آشپزخانه، می‌توانید دستور پخت‌های
      پیشنهادی بنتو را از این قسمت ببینید.
    </p>
    <div class="kitchen-empty-button" (click)="goToKitchen('kitchen')">
      <img src="assets/cookingbook/fridge-fill-blue.svg" alt="" />
      <p>افزودن به آشپزخانه</p>
    </div>
  </div>
  <div class="posts" *ngIf="suggestPost && suggestPost.recipes.length > 0">
    <div class="pos-rel">
      <p class="post-category-title">{{ suggestPost.name }}</p>
      <p
        class="post-category-show-more"
        *ngIf="suggestPost.recipes && suggestPost.recipes.length >= 10"
        (click)="showCategory(suggestPost.type, suggestPost.name)"
      >
        همه
      </p>
    </div>

    <app-cooking-story-slider
      [ready]="true"
      [posts]="suggestPost"
      [suggest]="true"
    ></app-cooking-story-slider>
  </div>
</div>
